import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";

@Injectable()
export class NavbarService {
  visible: Boolean = true;

  constructor(public database: AngularFireDatabase) {}

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  checkFokoExistence(fokoCode: String) {
    return this.database.object("/codes/" + fokoCode);
  }
}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/services/navbar-service.service.ts